import React from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import Text, { BoldText } from '../../../components/Text'
import ToggleSwitch from '../../../components/ToggleSwitch'
import { ContentBody, FormContainer, NotificationBody } from './style'
import authStore from '../../../stores/authStore'
import { spacing } from '../../../styles/_var'


const Notification = () => {
  const onNotificationsChange = (notificationState: boolean) => {
    authStore.updateSettings({ notification: notificationState })
  }

  if (!authStore.userSettings) return null

  return (
    <ContentBody>
      <BoldText variant="medium">NOTIFICATIONS</BoldText>
      <FormContainer>
        <NotificationBody>
          <NotificationText variant="regular">By turning on notifications switch, you have authorized matuskii to send you notifications to your mobile device</NotificationText>
          <ToggleSwitch
            id="notifications"
            checked={authStore.userSettings.notification}
            optionLabels={['On', 'Off']}
            onChange={onNotificationsChange} />
        </NotificationBody>
      </FormContainer>
    </ContentBody>
  )
}

export default observer(Notification)

const NotificationText = styled(({ ...rest }) => <Text {...rest} />)`
  margin-right: ${spacing.xs};
  flex: 1;
`